import { Alert } from 'foundations-components/transitional/components/Alert';
import { usePlatformDashboardSelector } from 'platform-dashboard-ui/store';
import { getDashboardDataSources } from 'platform-dashboard-ui/lib/dashboardDataSourceUtils';
import { selectDataSourcesPropertiesStatus } from 'platform-dashboard-ui/ducks/dataSourcePropertiesSlice';
import { RequestState } from 'platform-dashboard-ui/filter/requests/request-state';
import { selectDataSourcesMetadataStatus } from 'platform-dashboard-ui/ducks/dataSourceMetadataSlice';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const FiltersMetadataLoadFailureAlert = props => {
  const {
    dashboard
  } = props;
  const dataSourceIds = getDashboardDataSources(dashboard);
  const dataSourcesPropertiesStatus = usePlatformDashboardSelector(selectDataSourcesPropertiesStatus(dataSourceIds));
  const dataSourcesMetadataStatus = usePlatformDashboardSelector(selectDataSourcesMetadataStatus(dataSourceIds));
  const didDependenciesFail = dataSourcesMetadataStatus === RequestState.FAILED || dataSourcesPropertiesStatus === RequestState.FAILED;
  if (!didDependenciesFail) {
    return null;
  }
  return /*#__PURE__*/_jsx(Alert, {
    type: "warning",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dashboardHeader.dashboardFilters.metadataDependencyLoadFailure.title"
    }),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dashboardHeader.dashboardFilters.metadataDependencyLoadFailure.body"
    })
  });
};